import { Model } from "@vuex-orm/core";
import config from "../configs/Meeting";
import Building from "./Building";
import Mandate from "./Mandate";
import Resolution from "./Resolution";
import Media from "./Media";
import MeetingResolution from "./MeetingResolution";

export default class Meeting extends Model {
  static get entity() {
    return "meetings";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      licence_id: this.attr(null),
      building_id: this.attr(null),
      name: this.attr(null),
      slug: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      meeting_date: this.attr(null),
      address: this.attr(null),
      address_description: this.attr(null),
      access: this.attr(null),
      minutes: this.attr([]),
      freezed_meeting_details: this.attr([]),
      status: this.attr(null),
      minutes_media_id: this.attr(null),
      presence_media_id: this.attr(null),
      resolutions_count: this.attr(null),
      agenda_media_id: this.attr(null),
      zip_media_id: this.attr(null),
      current_resolution_id: this.attr(null),
      timer: this.attr(null),
      external_video_solution: this.attr(null),
      show_connection_details: this.attr(null),
      // NOTE: Here we will have a json with enabled meeting types: physic, correspondence, videoconference
      allowed_modalities: this.attr(null),
      // NOTE: This date will be the last date when the agency can set the votes for the bo
      last_reception_date: this.attr(null),
      meeting_room_name: this.attr(null),
      agenda_media: this.belongsTo(Media, "agenda_media_id"),
      minutes_media: this.belongsTo(Media, "minutes_media_id"),
      mandates: this.hasMany(Mandate, "meeting_id"),
      // HACK: ..
      building_owner_mandate: this.hasOne(Mandate, "meeting_id"),
      // ???: ??
      // resolutions: this.belongsToMany(Resolution, MeetingResolution, "meeting_id", "resolution_id"),
      // HACK: .. needed for list table .. sort by number of resolutions
      meeting_resolutions: this.hasMany(MeetingResolution, "meeting_id"),
      // HACK: to order by building name
      building: this.belongsTo(Building, "building_id"),
      signed_pv_media: this.belongsTo(Media, "signed_pv_media_id"),
      signed_pv_media_id: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
